import { render, staticRenderFns } from "./HomeTrustStrip.vue?vue&type=template&id=aaed1972&"
import script from "./HomeTrustStrip.vue?vue&type=script&lang=js&"
export * from "./HomeTrustStrip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports